export default __webpack_public_path__ + "static/GT-America-Extended-Bold-72c8fe96bd351b80e5b9a4107e69acb2.woff";